
import React from "react";
import api from "../../store/api";
import { useDispatch, useSelector } from "react-redux";
import { getTheme_type } from "../../store/actiontypes";
import { updateFavicon } from "../../utils/updateFavicon";

export const useTenant = () => {
    const dispatch = useDispatch();
    const tenant = useSelector((x:any) => x.tenantConfig);
    const [loading, setLoading] = React.useState(false);
  
    const setupTenantAsync = async () => {
        setLoading(true);
        var config = await api.requestmethods.get(`/api/tenant/config`);
        
        dispatch({ type: getTheme_type, payload: config });
        
        // Update page title
        document.title = `${config.Name} StateReport`; // "Belmar" or "Medquest"

        let tenantName = config.Name.toLowerCase();
        updateFavicon(tenantName);
        document.body.classList.add(`tenant-${tenantName}`);
        document.documentElement.style.setProperty('--primary-color', config.PrimaryColor);
        document.documentElement.style.setProperty('--secondary-color', config.SecondaryColor);
        setLoading(false);
        // setTimeout(, 1000)
        return config;
    }
    return {
      setupTenantAsync
    }
}